const borders = {};

export default borders;
